<mat-toolbar color="primary" class="fix-nav box">
  <button
    type="button"
    mat-icon-button
    class="visible-md"
    (click)="toggleSidebar()"
  >
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <div class="nav-brand">
    Smart WiFi
  </div>
  <span class="nav-spacer"></span>
  <!-- Language Switcher -->
  <button class="hidden-sm" mat-icon-button [matMenuTriggerFor]="language">
    <mat-icon>language</mat-icon>
  </button>
  <mat-menu #language="matMenu">
    <button mat-menu-item (click)="switchLanguage('bs')">
      <span>Bosanski</span>
    </button>
    <button mat-menu-item (click)="switchLanguage('en')">
      <span>English</span>
    </button>
    <button mat-menu-item (click)="switchLanguage('cs')">
      <span>Čeština</span>
    </button>
    <button mat-menu-item (click)="switchLanguage('ar')">
      <span>العربية</span>
    </button>
  </mat-menu>
  <!-- User Profile -->
  <button class="hidden-sm" mat-icon-button [matMenuTriggerFor]="profile">
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #profile="matMenu">
    <button mat-menu-item (click)="openProfile()">
      <mat-icon>person</mat-icon>
      <span>{{ 'NAVIGATION.PROFILE' | translate }}</span>
    </button>
  </mat-menu>
  <button mat-icon-button (click)="onLoggedout()">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</mat-toolbar>
